import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import classNames from 'classnames';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';
import SecurityCodeTooltip from '../fields/SecurityCodeTooltip';

const messages = defineMessages({
    placeholder: {
        id: 'dc.CreditCardForm.SecurityCode.placeholder',
        defaultMessage: 'Security Code*',
    },
});

const SecurityCode = ({
    value,
    autoFocus = false,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur = () => {},
    fullWidth = false,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="securityCode"
            value={value}
            wrapperClass={classNames(styles.right, {
                [styles.fullWidth]: fullWidth,
            })}
            placeholder={intl.formatMessage(messages.placeholder)}
            pattern="\d*"
            maxLength="4"
            autoComplete="cc-csc"
            dataTn="billing-securityCode"
            autoFocus={autoFocus}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
            rightDecorator={<SecurityCodeTooltip />}
            inputMode="numeric"
        />
    );
};

SecurityCode.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    fullWidth: PropTypes.bool,
};

export default SecurityCode;
